module.exports = __webpack_public_path__ + "static/img/OLIVER-GREEVES.41e83b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/OLIVER-GREEVES.jpg
// module id = o/XS
// module chunks = 0